export default __webpack_public_path__ + "static/media/fastener-placement-square-rounded-back.96d545e0.webp";